import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { NbAuthComponent } from '@nebular/auth';
import { DevStageGuard } from '../@core/services/guard/dev-stage-guard.service';
import { CallbackFacebookComponent } from './callback/facebook/callback-facebook.component';
import { CallbackGoogleComponent } from './callback/google/callback-google/callback-google.component';
import { NgxLoginComponent } from './login/login.component';
import { NgxLogoutComponent } from './logout/logout.component';
import { NgxRegisterComponent } from './register/register.component';
import { ReloginComponent } from './relogin/relogin.component';
import { NgxRequestPasswordComponent } from './request-password/request-password.component';
import { NgxResetPasswordComponent } from './reset-password/reset-password.component';
import { TokenComponent } from './token/token.component';

export const routes: Routes = [
  {
    path: '',
    component: NbAuthComponent,
    children: [
      {
        path: 'callback-google',
        component: CallbackGoogleComponent,
        canActivate: [DevStageGuard],
      },
      {
        path: 'callback-facebook',
        component: CallbackFacebookComponent,
        canActivate: [DevStageGuard],
      },
      {
        path: 'login',
        component: NgxLoginComponent,
      },
      {
        path: 'logout',
        component: NgxLogoutComponent,
      },
      {
        path: 'register',
        component: NgxRegisterComponent,
      },
      {
        path: 'relogin/:klient',
        component: ReloginComponent,
      },
      {
        path: 'request-password',
        component: NgxRequestPasswordComponent,
        canActivate: [DevStageGuard],
      },
      {
        path: 'reset-password',
        component: NgxResetPasswordComponent,
        canActivate: [DevStageGuard],
      },
      {
        path: 'token/:token',
        component: TokenComponent,
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class NgxAuthRoutingModule {
}
